import type { ReactNode } from 'react'

export type AccountHeaderProps = {
  firstName?: string
  email?: string
  loading?: boolean
  loadingSlot?: ReactNode
}

export function AccountHeader({
  firstName,
  email,
  loading,
  loadingSlot,
}: AccountHeaderProps) {
  if (loading) {
    return (
      loadingSlot ?? (
        <div className="space-y-2">
          <div className="h-7 w-48 bg-muted/30 rounded animate-pulse" />
          <div className="h-4 w-36 bg-muted/30 rounded animate-pulse" />
        </div>
      )
    )
  }

  return (
    <div>
      <h1 className="text-xl font-medium text-foreground tracking-tight">
        Welcome back, {firstName || 'there'}
      </h1>
      {email && (
        <p className="text-sm text-muted-foreground mt-1">{email}</p>
      )}
    </div>
  )
}
